<template>
    <v-dialog
        v-model="isLoading"
        hide-overlay
        persistent
        width="300">
        <v-card
            color="#e4af0c"
            dark>
            <v-card-text>
                {{ $t(`text.spinner`) }}
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0">
            </v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
	name: 'Spinner',
	props: {
		loading: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			isLoading: false,
		};
	},
	watch: {
		loading() {
			this.isLoading = this.loading;
		},
	},
	mounted() {
		this.isLoading = this.loading;
	},
};
</script>
